import React, { useMemo } from 'react';
import { Message, MessageProps } from 'primereact/message';
import { PMessageStyle as S } from './PMessage.style';
import { Icon } from 'components/Icon/Icon';

export const PMessage = React.forwardRef<Message, MessageProps>((props, ref) => {
  const icon = useMemo(() => {
    switch (props.severity) {
      case 'error':
        return <Icon icon="alertOctagonSolid" size={16} color="rose500" />;
      case 'warn':
        return <Icon icon="alertTriangleSolid" size={16} color="amber500" />;
      case 'success':
        return <Icon icon="checkCircleSolid" size={16} color="green500" />;
      default:
        return <Icon icon="infoCircleSolid" size={16} color="sky500" />;
    }
  }, [props.severity]);
  return (
    <S.Message
      {...props}
      content={
        <>
          <S.IconWrapper>{icon}</S.IconWrapper>
          {(props.content as any) || props.text}
        </>
      }
      ref={ref}
    />
  );
});
